import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

/**
 * Click-to-copy chip used for credentials (login/server/password).
 * Renders the value (or "—" if empty) and shows a brief "copied"
 * confirmation when clicked.
 */
export default function CopyChip({ value, label }) {
  const [copied, setCopied] = useState(false);

  function onCopy() {
    if (!value) return;
    navigator.clipboard?.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    });
  }

  return (
    <span
      className={`ct-copy${copied ? ' copied' : ''}`}
      onClick={onCopy}
      role="button"
      tabIndex={0}
      onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onCopy()}
      title={label ? `Click to copy ${label}` : 'Click to copy'}
    >
      {copied
        ? <><Check size={12} strokeWidth={2.5} /> copied</>
        : <>{value || '—'} {value && <Copy size={11} strokeWidth={2} />}</>
      }
    </span>
  );
}
